import api from './api';
import { config as runtimeConfig } from '../config.js';

const referralService = {
  /**
   * Get referrals list
   */
  async getReferrals(filters = {}, options = {}) {
    const params = {
      ...filters,
      page: options.page || 1,
      limit: options.limit || 20
    };
    const response = await api.get('/partners/referrals', { params });
    return response.data;
  },

  /**
   * Get referral by ID
   */
  async getReferralById(id) {
    const response = await api.get(`/partners/referrals/${id}`);
    return response.data;
  },

  /**
   * Get referral stats
   */
  async getStats(period = 'month') {
    const response = await api.get('/partners/referrals/stats', { params: { period } });
    return response.data;
  },


  /**
   * Export referrals to CSV
   */
  async exportReferrals(filters = {}) {
    const response = await api.get('/partners/referrals/export', {
      params: filters,
      responseType: 'blob'
    });
    return response.data;
  },

  /**
   * Generate referral link
   */
  generateReferralLink(code, params = {}) {
    const baseUrl = runtimeConfig.portalUrl;
    const url = new URL(`${baseUrl}/register`);
    url.searchParams.set('ref', code);

    if (params.source) url.searchParams.set('utm_source', params.source);
    if (params.medium) url.searchParams.set('utm_medium', params.medium);
    if (params.campaign) url.searchParams.set('utm_campaign', params.campaign);

    return url.toString();
  },

  /**
   * Copy to clipboard helper
   */
  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      return false;
    }
  }
};

export default referralService;
